//@ts-nocheck
const intersection = (a: string[], b: string[]) => {
  return a.filter((x) => b.includes(x));
};
const options = {
  // address: ["street_number", "route"],
  state: ["locality", "administrative_area_level_1"],
  sublocality: ["sublocality_level_1", "sublocality"],
  region: ["administrative_area_level_2"],
  vicinity: ["neighborhood"],
};
type OptionType = keyof typeof options;
function getCategory(types_ARR: string[]) {
  return Object.keys(options).filter((x) => {
    let v = intersection(options[x as OptionType], types_ARR);
    return v.length > 0;
  });
}

export function sortAddress(location_array: any[]) {
  let result = { state: "", vicinity: "", region: "", sublocality: "" };
  location_array.forEach((value, index) => {
    var r = getCategory(value.types);
    if (r.length > 0) {
      result[r[0]] = value["long_name"];
    }
  });
  if (result.state === "Federal Capital Territory") {
    result.state = "Abuja";
  }
  result.state = result.state.replace("State", "").trim();
  return result;
}

export function getAddressValue(location_array: any[]) {
  const first_two = location_array.slice(0, 2);
  let result = "";
  let transform = first_two.filter(
    (x) => intersection(x.types, ["route", "street_number"]).length > 0,
  );
  const result2 = transform.reduce((x, a) => `${x} ${a.long_name}`, result);
  return result2.trim();
}
